import { defineCommands, type CommandsOf, applyEntityDataChanges } from '../../commands/defineCommands';
import type { CanvasStoreContext } from '../../types';
import type { ShapeData } from '../../entityTypes';

export const shapeCommands = defineCommands({
  'shape.updateData': (ctx: CanvasStoreContext, event: {
    entityId: string; dataChanges: Partial<ShapeData>;
  }): CanvasStoreContext => applyEntityDataChanges(ctx, event.entityId, event.dataChanges),
});

export type ShapeCommand = CommandsOf<typeof shapeCommands>;
